//Images
import blog1 from "../images/removingOilStains/blog-oil-stain-banner.jpg";
import blog2 from "../images/installingPaversConcrete/blog-installing-pavers-banner.jpg";
import blog3 from "../images/jointSand/blog-joint-sand-001.jpg";
import blog4 from "../images/sealer/blog-sealer-001.jpg";
import blog5 from "../images/knowYourPaver/blog-permeable-vs-concrete-001.jpg";
import blog6 from "../images/patioEdging/blog-edge-patio-001.jpeg";
import blog7 from "../images/drivewayComparing/material-comparison-banner.jpg";
import blog8 from "../images/hillsideRetainingWall/blog-hillside-retaining-banner.jpeg";
import blog9 from "../images/firePit/blog-fire-pit-001.jpg";
import blog10 from "../images/bigDriveway/blog-driveway-size-001.jpg";
import blog11 from "../images/permeablePavers/permeable-blog-banner.jpg";
import blog12 from "../images/porcelainPavers/porcelain-pavers-banner.jpg";
import blog13 from "../images/permeablePaverManufacturers/permeable-paving-manufacturers-banner.jpg";
import blog14 from "../images/drivewayPatterns/blog-driveway-pattern-banner.jpg";
import blog15 from "../images/doItYourself/blog-do-it-yourself-001.jpg";
import blog16 from "../images/repairPaver/blog-fix-paver-001.jpg";
import blog17 from "../images/hoaPaver/blog-HOA-pavers-001.jpg";
import blog18 from "../images/drivewayCost/blog-driveway-cost-001.jpg";
import blog19 from "../images/paverWalkway/blog-paver-walkway-001.jpg";
import blog20 from "../images/chooseRightPaverColor/choose-the-right-paver-color-banner.jpg";


export const blogs = [
  {
    title:
      "Removing Stains on Pavers: From Oil and Grease to Hard Water and Rust",
    image: blog1,
    destination: "/blog/removing-stains-pavers-oil-grease-hard-water-rust",
    date: "August 18, 2016",
    categories: ["blog", "installation", "paving-stones"],
  },
  {
    title:
      "Installing Pavers Over Concrete: Best Practices and Potential Problems",
      image: blog2,
      destination: "/blog/installing-pavers-concrete-best-practices-potential-problems",
      date: "September 20, 2016",
      categories: ["blog", "contractors", "driveways", "patios", "paving-stones", "walkways"],
  },
  {
    title:
      "How to Secure Joint Sand Between Pavers",
      image: blog3,
      destination: "/blog/how-to-secure-joint-sand-between-pavers",
      date: "January 22, 2016",
      categories: ["blog", "paving-stones"],
  },
  {
    title:
      "Sealing Concrete Pavers: The How and Why and What to Consider",
      image: blog4,
      destination: "/blog/sealing-concrete-pavers-consider",
      date: "September 20, 2016",
      categories: ["blog", "contractors", "driveways", "patios", "paving-stones", "walkways"],
  },
  {
    title:
      "Know Your Paver Well: Permeable vs. Concrete Pavers",
      image: blog5,
      destination: "/blog/know-your-paver-well-permeable-vs-concrete-pavers",
      date: "August 18, 2015",
      categories: ["blog", "choosing-a-paving-material"],
  },
  {
    title:
      "What is the Best Way to Edge a Paver Patio? Our Favorite Ideas",
      image: blog6,
      destination: "/blog/best-way-edge-paver-patio-favorite-ideas",
      date: "September 13, 2016",
      categories: ["blog", "patios", "paving-stones", "retaining-walls", "walkways"],
  },
  {
    title:
      "Driveway Paving: Comparing Asphalt vs. Brick vs. Concrete",
      image: blog7,
      destination: "/blog/driveway-paving-comparing-asphalt-vs-brick-vs-concrete",
      date: "July 26, 2016",
      categories: ["blog", "driveways", "paving-stones"],
  },
  {
    title:
      "Constructing Hillside Retaining Walls in Los Angeles: What Every Homeowner Needs to Know",
      image: blog8,
      destination: "/blog/constructing-hillside-retaining-walls-los-angeles-every-homeowner-needs-know",
      date: "September 22, 2016",
      categories: ["blog", "contractors", "retaining-walls"],
  },
  {
    title:
      "Everything You Need to Know About Building Fire Pits in Your Southern California Backyard",
      image: blog9,
      destination: "/blog/everything-need-know-building-fire-pits-southern-california-backyard",
      date: "September 7, 2016",
      categories: ["blog", "patios"],
  },
  {
    title:
      "How Big Should a Driveway Be? Sizing Considerations for Your Los Angeles Home",
      image: blog10,
      destination: "/blog/big-driveway-sizing-considerations-los-angeles-home",
      date: "September 22, 2016",
      categories: ["blog", "driveways", "paving-stones", "permeable-pavers"],
  },
  {
    title:
      "Designing a Permeable Paver Surface",
      image: blog11,
      destination: "/blog/designing-a-permeable-paver-surface",
      date: "August 19, 2015",
      author: "Roy Kimchi",
      categories: ["blog", "permeable-pavers"],
  },
  {
    title:
      "Porcelain Pavers: Beauty, Durability and Ease of Maintenance",
      image: blog12,
      destination: "/blog/porcelain-pavers-beauty-durability-ease-maintenance",
      date: "January 9, 2017",
      categories: ["blog", "choosing-a-paving-material", "patios", "paving-stones", "walkways"],
  },
  {
    title:
      "Our Favorite Permeable Paving Manufacturers for Landscapes and Streetscapes",
      image: blog13,
      destination: "/blog/favorite-permeable-paving-manufacturers-landscapes-streetscapes",
      date: "August 21, 2016",
      categories: ["blog", "paving-stones", "permeable-pavers"],
  },
  {
    title:
      "Our 3 Favorite Driveway Brick Paving Patterns",
      image: blog14,
      destination: "/blog/3-favorite-driveway-brick-paving-patterns",
      date: "August 7, 2016",
      categories: ["blog", "driveways", "paving-stones"],
  },
  {
    title:
      "Do-It-Yourself Paver Installation",
      image: blog15,
      destination: "/blog/do-it-yourself-paver-installation",
      date: "November 10, 2010",
      categories: ["blog", "driveways", "installation", "paving-stones"],
  },
  {
    title:
      "How to Repair a Broken Driveway Paving Stone in 3 Steps",
      image: blog16,
      destination: "/blog/repair-broken-driveway-paving-stone",
      date: "August 11, 2015",
      categories: ["blog", "paving-stones"],
  },
  {
    title:
      "The Best Pavers for Driveways, Streets and Sidewalks for a Homeowners Association",
      image: blog17,
      destination: "/blog/best-pavers-driveways-streets-sidewalks-homeowners-association",
      date: "August 29, 2016",
      categories: ["blog", "choosing-a-paving-material", "driveways", "paving-stones", "walkways"],
  },
  {
    title:
      "How Much Does Brick Driveway Paving Cost?",
      image: blog18,
      destination: "/blog/how-much-does-brick-driveway-paving-cost",
      date: "August 7, 2016",
      categories: ["blog", "driveways", "installation"],
  },
  {
    title:
      "14 Paver Walkway Ideas for Star Quality Curb Appeal in Southern California",
      image: blog19,
      destination: "/blog/14-paver-walkway-ideas",
      date: "December 1, 2016",
      categories: ["blog", "driveways", "paving-stones"],
  },
  {
    title:
      "How to choose the right paver color (7 tips to consider)",
    image: blog20,
    destination: "/blog/how-to-choose-the-right-paver-color",
    date: "September 8, 2022",
    categories: ["blog", "permeable-pavers", "paving-stones"],
  },
]
.sort((a, b) => {
  let date1 = new Date(a.date).getTime();
  let date2 = new Date(b.date).getTime();
  return date2 - date1;
});
